import mapGeneralProduct, { RawProduct as RawGeneralProduct } from '~/Api/Product/mapProduct';
import { Product } from '~/Api/User/ProductGroup/CaLabeling/Product';

export interface RawProduct {
	packageSizeForCalculation: number | null;
	product: RawGeneralProduct;
}

export const mapProduct = (product: RawProduct): Product => {
	return new Product(product.packageSizeForCalculation, mapGeneralProduct(product.product));
};
